import { createSlice } from '@reduxjs/toolkit';
import screenFull from 'screenfull';
import {
  APP_VIEW,
  CHAT_BEHAVIOUR,
  EVENT_TYPE,
  FINAL_EVENT_STATUS,
  PLAYER_STATES,
  SESSION_STATE,
  DEFAULT_API_KEY,
  EVENT_STATUS,
  CHAT_MODE,
  STATE_MODE,
  GO_LIVE_STATES,
  AUTO_PLAY_BEHAVIOUR,
  CAST_STATE,
  PLAYER_BG,
  STREAM_TYPE,
  CALLING_STATE,
  CANVAS_ITEM_TYPES,
  GRAPHIC_THEMES,
} from '../../constants';
import { getEventStatus, getEventType, preparePlayListWelcomeData } from './helpers';
import { getOrientation, evalValue, hasNotValue, isScreenshotSupported } from '../../utils';

const app = createSlice({
  name: 'app',
  initialState: {
    eventId: null,
    config: {
      apiKey: DEFAULT_API_KEY,
      slikeApiKeyMWeb: '',
      slikeApiKeyWeb: '',
      env: 'stg',
      version: '3.6.50',
      debug: false,
      skipSW: false,
      audCount: true,
      screenshot: true,
      fs: true,
      drMode: 1,
      chatMode: CHAT_MODE.SOCKET_ONLY,
      stateMode: STATE_MODE.SOCKET_ONLY,
      nameChange: false,
      theme: 'cleo',
      showRecording: false,
      gaId: null,
      gaPrefix: 'cleo',
      canvasOnly: 0,
      reduxLogging: false,
      hlsLoaderOnly: 1,
      playerBg: PLAYER_BG.BLURRED_VIDEO,
      ssCheck: false,
      drawPartialCanvas: 1,
      forceFsMobile: 1,
      showCursor: ['pencil', 'eraser'],
      apiJsonKey: 'el5mKsaGcwjOibRJ',
      webview: 0,
      public: false,
      dvr: false,
      controls: false,
      headless: false,
      bgpause: false,
      ptype: '',
      lowlatency: true,
      vod: false,
      skipAd: false,
      skipPre: false,
      skipMid: false,
      adsData: {},
      isPrime: false,
      pageUrl: '',
      pageSection: '',
      pageTpl: '',
      pid: '',
      gdpr: false,
      pib: true,
      puppet: false,
      skipAnalytics: false,
    },
    loader: true,
    error: '',
    welcomeData: null,
    sessionState: -1,
    view: null,
    title: '',
    eventStatus: null,
    qna: false,
    comments: false,
    screenshot: false,
    eventType: null,
    userDisplayName: null,
    proceedClickCaptured: false,
    playerState: null,
    activeTab: null,
    takeScreenshot: false,
    liveDuration: null,
    welcomeReceivedTime: null,
    showAudCount: null,
    audCount: 0,
    isFullScreen: false,
    recordingList: [],
    ssAdminData: [],
    ssAdminDataUnread: [],
    ssDeleteId: null,
    mode: getOrientation(),
    showControl: true,
    desc: '',
    networkError: false,
    ssPreview: false,
    clientScreenshots: false,
    screenshotList: [],
    share: null,
    stopControlHiding: false,
    stopShowingControl: false,
    playerVisibility: true,
    hideTabNavigation: true,
    DRMode: false,
    aliveData: {},
    blocked: false,
    allowedUserTime: null,
    elapsedTime: 0,
    sessionExpired: false,
    limitedViewing: null,
    hookUrl: '',
    hookBehavior: null,
    chatDomLoaded: false,
    banner: null,
    reactions: {},
    showReaction: true,
    ShowLiveDuration: true,
    playerError: false,
    isScreenshotSupported: true,
    documentVisibility: true,
    playerReadyForSS: false,
    inActive: null,
    inActiveDuration: null,
    countDown: null,
    shareBox: false,
    bitRate: 'Auto',
    goLive: GO_LIVE_STATES.NEVER_LIVE,
    ssExist: false,
    chatLoaded: false,
    poster: '',
    chatRulesState: 0,
    autoPlayBehavior: AUTO_PLAY_BEHAVIOUR.NEVER,
    autoPlayAllowed: false,
    muted: false,
    autoPlayUnmute: false,
    welcomeSS: true,
    previewAutoHideTime: 30000,
    layers: null,
    castState: CAST_STATE.NOT_CONNECTED,
    castReady: false,
    castVideoStarted: false,
    videoVolume: 100,
    pipMode: false,
    quickComments: true,
    fixedTabControls: true,
    crop: false,
    momentsAllowed: null,
    mLEnable: null,
    hideTab: true,
    apiKeyJson: null,
    apiJsonConfig: {
      changeName: false,
      autoPlay: AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND,
      theme: 'cleo',
      showRec: false,
      playerBg: PLAYER_BG.BLURRED_VIDEO,
      skipForm: true,
    },
    pinnedMsg: null,
    unreadAdminMsgs: [],
    showCommentsRec: getOrientation() === 'portrait',
    recordingComment: false,
    requestLogin: false,
    googleLoginRequired: false,
    forcedPlayerState: 0,
    livesdkLoaded: false,
    closeTabOnClick: false,
    forceDestroyed: false,
    PmStreamState: 0,
    BkStreamState: 0,
    seekToLive: false,
    originalEventType: 0,
    audioStream: [],
    StreamState: 0,
    enableDvr: false,
    convertToVod: false,
    isRecording: false,
    recData: null,
    callingState: CALLING_STATE.NOT_INITIATED,
    handRaiseOnce: false,
    handRaise: false,
    reloadRtcPlayer: null,
    handRaiseState: { visible: false, disabled: false },
    canvasLiveState: false,
    items: [],
    manifestless: false,
    allBanners: [],
    playlistDetails: {},
    loopPlaylist: false,
    playListWelcomeData: {},
    syncTimeDifference: 0, //relative time difference between client and server in ms
    originalEventStatus: 0,
    currentSimuliveIndex: -1,
    adActive: false,
    vidDataLoaded: false,
    canvasMeta: {
      theme: GRAPHIC_THEMES.THEME_ONE,
      tickerScroll: true,
      primaryColor: '#D51035',
      secondaryColor: '#ffffff',
      secondaryTextColor: '#D51035',
      textColor: '#fff',
      secondaryFontSize: 20,
      fontSize: 20,
      secondaryFontFamily: 'Roboto',
      fontFamily: 'Roboto',
      logoHeight: 0,
      logoWidth: 0,
      logoX: 0,
      logoY: 0,
      slideNumber: 1,
    },
  },
  reducers: {
    setLoader(state, action) {
      state.loader = action.payload.loader;
    },
    setAppConfig(state, action) {
      state.apiKeyJson = { ...action.payload.apiKeyJson };
      state.config = {
        ...state.config,
        ...action.payload.config,
      };
      state.eventId = action.payload.config.eventId;
      state.muted = action.payload.config.muted;
      if (action.payload.config.jwtData.name) {
        state.userDisplayName = action.payload.config.jwtData.name;
      }
      if (action.payload.config.jwtData.timelimit) {
        state.allowedUserTime = action.payload.config.jwtData.timelimit;
      }
      if ('limitedViewing' in action.payload.config.jwtData && action.payload.config.jwtData.timelimit) {
        state.limitedViewing = action.payload.config.jwtData.limitedViewing;
        if (state.limitedViewing) {
          state.config.cast = false;
        }
      }
      if (action.payload.config.jwtData.behavior) {
        state.hookBehavior = action.payload.config.jwtData.behavior;
      }
      if (action.payload.config.jwtData.url) {
        state.hookUrl = action.payload.config.jwtData.url;
      }
      if (action.payload.config.fs) {
        if (!screenFull.isEnabled) {
          state.config.fs = false;
        }
      }
      if (!hasNotValue(action.payload.apiKeyJson?.conf?.ui?.playerBg)) {
        state.apiJsonConfig.playerBg = action.payload.apiKeyJson.conf.ui.playerBg;
      }
      if (typeof action.payload.config.playerBg === 'number') {
        state.apiJsonConfig.playerBg = action.payload.config.playerBg;
      }
      if (state.apiJsonConfig.playerBg) {
        if (
          state.apiJsonConfig.playerBg === PLAYER_BG.BLURRED_VIDEO &&
          window.Modernizr &&
          window.Modernizr.backdropfilter + window.Modernizr.cssfilters === 0
        ) {
          state.apiJsonConfig.playerBg = PLAYER_BG.OVERLAY_VIDEO;
        }
      }

      if (state.apiJsonConfig.playerBg !== PLAYER_BG.DISABLED && !isScreenshotSupported()) {
        state.apiJsonConfig.playerBg = PLAYER_BG.OVERLAY_IMAGE;
      }
      // state.apiJsonConfig.playerBg = 1;

      if (state.config.castMode) {
        state.config.clientBgVideo = 0;
        state.config.gaId = null;
      }
      if (state.config.headless) {
        state.config.controls = false;
      }
      if (action.payload.config.autoPlay !== null) {
        state.apiJsonConfig.autoPlay = action.payload.config.autoPlay;
      } else if (!hasNotValue(action.payload.apiKeyJson?.conf?.player?.autoPlay)) {
        state.apiJsonConfig.autoPlay = action.payload.apiKeyJson.conf.player.autoPlay;
      }

      if (!hasNotValue(action.payload.apiKeyJson?.conf?.ui?.closeTabonClick)) {
        state.closeTabOnClick = action.payload.apiKeyJson.conf.ui.closeTabonClick;
      }

      if (action.payload.config.forceFsMobile !== null) {
        state.config.forceFsMobile = action.payload.config.forceFsMobile;
      } else if (!hasNotValue(action.payload.apiKeyJson?.conf?.ui?.forcefsMobile)) {
        state.config.forceFsMobile = action.payload.apiKeyJson?.conf?.ui?.forcefsMobile;
      }

      if (action.payload.config.theme !== null) {
        state.apiJsonConfig.theme = action.payload.config.theme;
      } else if (!hasNotValue(action.payload.apiKeyJson?.conf?.ui?.theme)) {
        state.apiJsonConfig.theme = action.payload.apiKeyJson.conf.ui.theme;
      }
      if (action.payload.config.showRecording !== null) {
        state.apiJsonConfig.showRec = action.payload.config.showRecording;
      } else if (!hasNotValue(action.payload.apiKeyJson?.conf?.endScreen?.showRec)) {
        state.apiJsonConfig.showRec = action.payload.apiKeyJson.conf.endScreen.showRec;
      }
      if (action.payload.config.nameChange !== null) {
        state.apiJsonConfig.skipForm = action.payload.config.nameChange ? false : true;
      } else if (!hasNotValue(action.payload.apiKeyJson?.conf?.welcomeScreen?.changeName)) {
        state.apiJsonConfig.skipForm = action.payload.apiKeyJson.conf.welcomeScreen.changeName ? false : true;
      }
      if (action.payload.config?.activeTab === null && !hasNotValue(action.payload.apiKeyJson.conf.ui.activeTab)) {
        state.config.activeTab = action.payload.apiKeyJson.conf.ui.activeTab;
      }
      if (action.payload.config.jwtData?.meta && 'isloggedin' in action.payload.config.jwtData.meta) {
        state.requestLogin = !action.payload.config.jwtData?.meta?.isloggedin;
      }

      if (action.payload.config.skipAd !== null) {
        state.config.skipAd = action.payload.config.skipAd;
      } else if (!hasNotValue(action.payload.apiKeyJson?.conf?.player?.skipAd)) {
        state.config.skipAd = action.payload.apiKeyJson.conf.player.skipAd;
      }
      if (!hasNotValue(action.payload.config?.adsData)) {
        state.config.adsData = action.payload.config?.adsData;
      } else if (
        !hasNotValue(
          action.payload.apiKeyJson?.conf?.player?.adsData &&
            Object.keys(action.payload.apiKeyJson?.conf?.player?.adsData).length,
        )
      ) {
        state.config.adsData = action.payload.apiKeyJson.conf.player.adsData;
      } else {
        state.config.skipAd = true;
      }
      if (!hasNotValue(action.payload.apiKeyJson?.conf?.player?.skipPre)) {
        state.config.skipPre = action.payload.apiKeyJson.conf.player.skipPre;
      }
      if (!hasNotValue(action.payload.apiKeyJson?.conf?.player?.skipMid)) {
        state.config.skipMid = action.payload.apiKeyJson.conf.player.skipMid;
      }
      if (!hasNotValue(action.payload.apiKeyJson?.conf?.player?.slikeApiKeyMWeb)) {
        state.config.slikeApiKeyMWeb = action.payload.apiKeyJson.conf.player.slikeApiKeyMWeb;
      }
      if (!hasNotValue(action.payload.apiKeyJson?.conf?.player?.slikeApiKeyMWeb)) {
        state.config.slikeApiKeyWeb = action.payload.apiKeyJson.conf.player.slikeApiKeyWeb;
      }
      if (state.config.puppet) {
        state.config.headless = true;
        state.config.skipAd = true;
        state.config.skipAnalytics = true;
      }
    },
    setClientConfig(state, action) {
      state.config = { ...state.config, ...action.payload };
    },
    resetAppConfig(state, action) {
      state.config = {
        ...state.config,
        jwtData: action.payload.jwtData,
        jwt: action.payload.jwt,
      };
      if ('skipForm' in action.payload) {
        state.apiJsonConfig = {
          ...state.apiJsonConfig,
          skipForm: action.payload.skipForm,
        };
        if (!action.payload.skipForm) {
          //restrict autoplay behaviour
          state.muted = false;
          state.autoPlayAllowed = false;
          state.autoPlayBehavior = AUTO_PLAY_BEHAVIOUR.NEVER;
        }
      }
      if ('eventId' in action.payload) {
        state.eventId = action.payload.eventId;
        state.config = { ...state.config, eventId: action.payload.eventId };
      }
      if ('isRecording' in action.payload) {
        state.isRecording = action.payload.isRecording;
      }
      if ('recData' in action.payload) {
        state.recData = action.payload.recData;
      }
    },
    setGoogleLoginRequired(state, action) {
      state.googleLoginRequired = action.payload;
      if (action.payload) {
        state.view = APP_VIEW.WELCOME;
      }
    },
    setAutoPlayBehavior(state, action) {
      state.autoPlayBehavior = action.payload;
      if (action.payload === AUTO_PLAY_BEHAVIOUR.ALLOW || action.payload === AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND) {
        state.autoPlayAllowed = true;
      }
      if (action.payload === AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND) {
        state.muted = true;
      }
    },
    setAppError(state, action) {
      console.error('set_app_error', action.payload);
      state.view = APP_VIEW.ERROR;
      state.error = action.payload.msg;
    },
    setWelcomeData(state, action) {
      state.reaction = action.payload.reaction;
      state.reactions = action.payload.reactions ?? {};
      state.welcomeData = action.payload;
      state.PmStreamState = action.payload.state.PmStreamState;
      state.StreamState = action.payload.state.StreamState;
      state.BkStreamState = action.payload.state.BkStreamState;
      state.eventStatus = getEventStatus(action.payload.state.Status, action.payload.state.StreamState);
      state.title = action.payload.meta.title;
      state.desc = action.payload.meta.desc;
      state.share = action.payload.meta.share;
      state.qna = state.config.qna ? action.payload.state.QnAEnabled : false;
      state.comments = state.config.comments
        ? action.payload.state.ChatMode === CHAT_BEHAVIOUR.PUBLIC
          ? true
          : false
        : false;
      state.screenshot = action.payload.state.Screenshot;
      state.showLiveDuration = action.payload.state.ShowDuration;
      state.showReaction = action.payload.state.ShowReaction;
      state.goLive = action.payload.state.GoLive;
      state.eventType = getEventType(action.payload.etype, state.isRecording);
      state.originalEventType = action.payload.etype;
      state.reactionStats = action.payload.state.ReactionStats;
      state.quickComments = action.payload.state.QuickComments;
      state.fixedTabControls = evalValue(action.payload.state.FixedTabControls, state.fixedTabControls);
      state.momentsAllowed = action.payload.state.MomentsAllowed;
      state.mLEnable = action.payload.state.MLEnable;
      if (action.payload.name) {
        state.userDisplayName = action.payload.name;
      }
      if (!action.payload.meta.poster) {
        state.welcomeData.meta.poster = `${window.location.origin}${window.location.pathname
          .replace(`${state.eventId}`, '')
          .replace('//', '/')}assets/bg.jpg`;
      }
      state.poster = state.welcomeData.meta.poster;
      if (state.mode === 'portrait' && action.payload.meta.mobileposter) {
        state.poster = action.payload.meta.mobileposter;
      }
      state.liveDuration = action.payload.state.LiveDuration || 0;
      state.audCount = action.payload.ac || 0;
      state.welcomeReceivedTime = Date.now();
      state.showAudCount = state.config.audCount ? action.payload.state.AudCount : false;
      if (action.payload.reclist && action.payload.reclist.length) {
        state.recordingList = action.payload.reclist;
      }
      if (action.payload.ss && action.payload.ss.length) {
        state.ssAdminData = action.payload.ss;
      }
      if (hasNotValue(state.welcomeData?.meta.sttype)) {
        state.welcomeData.meta.sttype = STREAM_TYPE.LANDSCAPE;
      }
      if (action.payload.ss && action.payload.ss.length && action.payload.state.Status !== EVENT_STATUS.EVENT_RUNNING) {
        state.screenshotList = action.payload.ss;
      }
      if (state.qna || state.comments || state.config.screenshot) {
        state.hideTabNavigation = false;
      }
      if (action.payload?.studio?.meta) {
        let meta = action.payload?.studio?.meta;
        let data = action.payload;
        if (!meta.hasOwnProperty('primaryColor') && data?.meta?.primarytheme?.basecolor) {
          meta = { ...meta, primaryColor: data?.meta?.primarytheme?.basecolor };
        }
        if (!meta.hasOwnProperty('secondaryTextColor') && data?.meta?.secondarythem?.textcolor) {
          meta = { ...meta, secondaryTextColor: data?.meta?.secondarythem?.textcolor };
        }
        if (!meta.hasOwnProperty('secondaryColor') && data?.meta?.secondarythem?.basecolor) {
          meta = { ...meta, secondaryColor: data?.meta?.secondarythem?.basecolor };
        }
        if (!meta.hasOwnProperty('textColor') && data?.meta?.primarytheme?.textcolor) {
          meta = { ...meta, textColor: data?.meta?.primarytheme?.textcolor };
        }
        if (!meta.hasOwnProperty('fontFamily') && data?.meta?.primarytheme?.fontfamily) {
          meta = { ...meta, fontFamily: data?.meta?.primarytheme?.fontfamily };
        }
        if (!meta.hasOwnProperty('fontSize') && data?.meta?.primarytheme?.fontsize) {
          meta = { ...meta, fontSize: parseInt(data?.meta?.primarytheme?.fontsize) };
        }
        if (!meta.hasOwnProperty('secondaryFontFamily') && data?.meta?.secondarythem?.fontfamily) {
          meta = { ...meta, secondaryFontFamily: data?.meta?.secondarythem?.fontfamily };
        }
        if (!meta.hasOwnProperty('secondaryFontSize') && data?.meta?.secondarythem?.fontsize) {
          meta = { ...meta, secondaryFontSize: parseInt(data?.meta?.secondarythem?.fontsize) };
        }
        state.canvasMeta = { ...state.canvasMeta, ...meta };
      }
      if (action.payload.ct) {
        state.elapsedTime = action.payload.ct;
      }
      if (action.payload.cr) {
        state.chatRulesState = action.payload.cr;
      }
      state.enableDvr = action.payload.meta?.enabledvr ?? false;
      if (state.config.vod !== null) state.convertToVod = state.config.vod;
      else state.convertToVod = action.payload.meta?.vod ?? false;
      if (state.config.lowlatency !== null) state.manifestless = state.config.lowlatency;
      else state.manifestless = action.payload.meta?.lowlatency ?? false;
      if (state.enableDvr) {
        state.config.controls = true;
      }
      if (action.payload.meta.lmtviewing && state.allowedUserTime && state.limitedViewing === null) {
        state.limitedViewing = true;
        state.config.cast = false;
        state.hookUrl = action.payload.meta.lmtviewing.hook_url ? action.payload.meta.lmtviewing.hook_url : '';
        state.hookBehavior = parseInt(action.payload.meta.lmtviewing.hook);
      }

      if (state.apiJsonConfig && state.apiJsonConfig.theme === 'et') {
        if (state.comments) {
          state.activeTab = 'comments';
        } else if (state.qna) {
          state.activeTab = 'qna';
        }
      } else {
        if (
          (state.config.activeTab === 'comments' && state.comments) ||
          (state.config.activeTab === 'qna' && state.qna) ||
          (state.config.activeTab === 'screenshot' && state.screenshot)
        ) {
          state.activeTab = state.config.activeTab;
        }
      }
      if (state.config.activeTab === 'comments' && state.eventType === EVENT_TYPE.HLS_RECORDING) {
        state.showCommentsRec = true;
      }
      if (action.payload.etype === EVENT_TYPE.WB_LIVE || action.payload.etype === EVENT_TYPE.WB_RECORDING) {
        // override autoplay behaviour for whiteboard
        state.muted = false;
        state.autoPlayAllowed = false;
        state.autoPlayBehavior = AUTO_PLAY_BEHAVIOUR.NEVER;
        state.config.skipForm = false;
        state.showCommentsRec = false;
      }
      state.handRaise = action.payload.state.HandRaiseEnabled;
      if (action.payload.state.HandRaiseEnabled) {
        state.handRaiseOnce = true;
      }

      state.layers = action.payload.meta.ML;
      if (state.isRecording && state.recData !== null) {
        state.welcomeData = { ...state.welcomeData, recording: state.recData };
      }
      // if (action.payload.studio?.canvas.length > 0) {
      //   const caption = action.payload.studio?.canvas.find((item) => item.type === 'caption');
      //   if (caption) {
      //     const payload = { action: 1, aston_id: caption.id, duration: -1, id: caption.id, name: caption.id, repeatCount: null, timestamp: Date.now(), type: 'text', url: caption.heading };
      //     state.banner = payload;
      //   }
      // }
      if (action.payload.studio?.canvas && action.payload.studio?.canvas?.length > 0) {
        const idx = action.payload.studio.canvas.findIndex((o) => o.id === action.payload.userid);
        if (idx !== -1) {
          state.canvasLiveState = true;
        }
      }
      if (action.payload?.allbanner && action.payload?.allbanner?.length > 0) {
        state.allBanners = [...(action.payload?.allbanner ?? [])];
      }
      if (action.payload.etype === EVENT_TYPE.SIMULIVE && action.payload.ply) {
        state.playListWelcomeData = preparePlayListWelcomeData(action.payload.ply);
        state.loopPlaylist = action.payload.state.lpl;
        state.currentSimuliveIndex = action.payload.ply.i;
      }
      state.syncTimeDifference = Date.now() - action.payload.ts;
      state.originalEventStatus = action.payload.state.Status;
    },
    setSSAdminData(state, action) {
      if (action.payload) {
        state.ssAdminData = [...action.payload];
      }
    },
    setSessionState(state, action) {
      state.sessionState = action.payload;
    },
    setPoster(state, action) {
      state.poster =
        action.payload.meta.poster ??
        `${window.location.origin}${window.location.pathname
          .replace(`${state.eventId}`, '')
          .replace('//', '/')}assets/bg.jpg`;
      if (state.mode === 'portrait' && action.payload.meta.mobileposter) {
        state.poster = action.payload.meta.mobileposter;
      }
    },
    setAppView(state) {
      const {
        eventStatus,
        sessionState,
        proceedClickCaptured,
        eventType,
        playerState,
        goLive,
        autoPlayAllowed,
        view,
        convertToVod,
        originalEventType,
        config,
      } = state;
      if (eventStatus === FINAL_EVENT_STATUS.NOT_STARTED) {
        state.view = APP_VIEW.WELCOME;
      } else if (eventStatus === FINAL_EVENT_STATUS.ENDED) {
        if (originalEventType === EVENT_TYPE.WEB_STUDIO && config.ptype === 'rtc') {
          state.view = APP_VIEW.END;
        } else if (eventType === EVENT_TYPE.HLS_LIVE) {
          if (
            (playerState === PLAYER_STATES.STOPPED && !convertToVod) ||
            originalEventType === EVENT_TYPE.SIMULIVE ||
            playerState === null ||
            goLive === GO_LIVE_STATES.ENDED
          ) {
            state.view = APP_VIEW.END;
          }
        } else if (eventType === EVENT_TYPE.HLS_RECORDING) {
          if (autoPlayAllowed) {
            state.view = APP_VIEW.MAIN;
          } else {
            if (proceedClickCaptured) {
              state.view = APP_VIEW.MAIN;
            } else {
              state.view = APP_VIEW.WELCOME;
            }
          }
        } else if (eventType === EVENT_TYPE.WB_RECORDING) {
          state.view = APP_VIEW.MAIN;
        } else {
          state.view = APP_VIEW.END;
        }
      } else {
        if (sessionState === SESSION_STATE.REJECTED) {
          state.view = APP_VIEW.WELCOME;
        } else if (sessionState === SESSION_STATE.CONNECTED) {
          if (
            goLive === GO_LIVE_STATES.STARTED &&
            (eventStatus === FINAL_EVENT_STATUS.RUNNING || view === APP_VIEW.MAIN)
          ) {
            if (view === APP_VIEW.WELCOME && autoPlayAllowed) {
              state.loader = true;
            }
            if (autoPlayAllowed) {
              state.view = APP_VIEW.MAIN;
              if (state.limitedViewing && state.elapsedTime > state.allowedUserTime) {
                state.view = APP_VIEW.WELCOME;
              }
            } else {
              if (proceedClickCaptured) {
                state.view = APP_VIEW.MAIN;
              } else {
                state.view = APP_VIEW.WELCOME;
              }
            }
          } else if (goLive === GO_LIVE_STATES.PAUSED) {
            if (view !== APP_VIEW.MAIN) {
              state.view = APP_VIEW.WELCOME;
            }
          } else if (goLive === GO_LIVE_STATES.ENDED || view === APP_VIEW.END) {
            state.view = APP_VIEW.END;
          } else {
            state.view = APP_VIEW.WELCOME;
          }
        }
      }
    },
    setStateUpdate(state, action) {
      //update welcome Received time when event starts
      if (
        state.originalEventStatus !== EVENT_STATUS.EVENT_RUNNING &&
        action.payload.Status === EVENT_STATUS.EVENT_RUNNING
      ) {
        state.welcomeReceivedTime = Date.now();
      }
      state.originalEventStatus = action.payload.Status;
      state.eventStatus = getEventStatus(action.payload.Status, action.payload.StreamState);
      state.StreamState = action.payload.StreamState;
      state.PmStreamState = action.payload.PmStreamState;
      state.BkStreamState = action.payload.BkStreamState;
      state.qna = state.config.qna ? action.payload.QnAEnabled : false;
      state.comments = state.config.comments
        ? action.payload.ChatMode === CHAT_BEHAVIOUR.PUBLIC
          ? true
          : false
        : false;
      state.showAudCount = state.config.audCount ? action.payload.AudCount : false;
      state.screenshot = action.payload.Screenshot;
      state.liveDuration = action.payload.LiveDuration;
      state.showLiveDuration = action.payload.ShowDuration;
      state.showReaction = action.payload.ShowReaction;
      state.goLive = action.payload.GoLive;
      state.reactionStats = action.payload.ReactionStats;
      state.quickComments = action.payload.QuickComments;
      state.fixedTabControls = evalValue(action.payload.FixedTabControls, state.fixedTabControls);
      if (state.qna || state.comments || state.config.screenshot) {
        state.hideTabNavigation = false;
      }
      state.handRaise = action.payload.HandRaiseEnabled;
      if (action.payload.HandRaiseEnabled) {
        state.handRaiseOnce = true;
      }
      state.momentsAllowed = action.payload.MomentsAllowed;
      state.mLEnable = action.payload.MLEnable;
      state.loopPlaylist = action.payload.lpl;
    },
    proceedClick(state, action) {
      if (action.payload.displayName) {
        state.userDisplayName = action.payload.displayName;
      }
      state.proceedClickCaptured = true;
      const { eventStatus, eventType } = state;
      if (eventType === EVENT_TYPE.HLS_RECORDING) {
        state.loader = true;
        state.view = APP_VIEW.MAIN;
      } else {
        if (
          eventStatus === FINAL_EVENT_STATUS.RUNNING ||
          eventStatus === FINAL_EVENT_STATUS.PAUSED ||
          eventStatus === FINAL_EVENT_STATUS.STARTING
        ) {
          state.loader = true;
          if (action.payload.bForce) {
            state.view = null;
          } else {
            state.view = APP_VIEW.MAIN;
          }
        } else {
          if (action.payload.bForce) {
            state.loader = true;
            state.view = null;
          }
        }
      }
    },
    setPlayerState(state, action) {
      const { eventStatus, eventType, convertToVod } = state;
      state.playerState = action.payload;
      if (
        eventType === EVENT_TYPE.HLS_LIVE &&
        action.payload === PLAYER_STATES.STOPPED &&
        eventStatus === FINAL_EVENT_STATUS.ENDED
      ) {
        //in case of convert to vod on end enabled , skip event end page
        if (convertToVod) return;
        state.view = APP_VIEW.END;
      }
    },
    openTab(state, action) {
      // empty unread list on opening respective tab
      if (action.payload === 'screenshot') {
        state.ssAdminDataUnread = [];
      }
      if (action.payload === 'comments') {
        state.unreadAdminMsgs = [];
      }
      if (
        (state.eventType === EVENT_TYPE.WB_LIVE || (state.closeTabOnClick && state.mode !== 'portrait')) &&
        state.activeTab === action.payload
      ) {
        state.hideTab = true;
        state.activeTab = null;
      } else {
        state.activeTab = action.payload;
        state.hideTab = false;
      }
    },
    closeTab(state, action) {
      state.activeTab = null;
      state.hideTab = true;
    },
    takeScreenshotClick(state, action) {
      state.takeScreenshot = true;
    },
    resetTakeScreenshot(state, action) {
      state.takeScreenshot = false;
    },
    HidingControl(state, action) {
      state.stopControlHiding = !state.stopControlHiding;
    },
    updateAudCount(state, action) {
      state.audCount = action.payload;
    },
    updateReactions(state, action) {
      state.reactions = action.payload;
    },
    forceStateUpdate(state, action) {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });
    },
    toggleFullScreen(state, action) {
      state.isFullScreen = action.payload;
    },
    setRecordings(state, action) {
      state.recordingList = action.payload;
    },
    addScreenShot(state, action) {
      if (state.activeTab === 'screenshot') {
        state.ssAdminDataUnread = [];
      } else if (state.ssAdminData.findIndex((ss) => ss.id === action.payload.id) === -1) {
        state.ssAdminDataUnread = [...state.ssAdminDataUnread, action.payload];
      }
      state.ssAdminData = [action.payload];
    },
    deleteScreenShot(state, action) {
      if (state.ssAdminDataUnread.length > 0) {
        state.ssAdminDataUnread = state.ssAdminDataUnread.filter((ss) => ss.id !== action.payload);
      }
      state.ssDeleteId = action.payload;
    },
    handleResize(state, action) {
      state.mode = getOrientation();
      if (state.welcomeData) {
        if (state.mode === 'portrait' && state.welcomeData.meta.mobileposter) {
          state.poster = state.welcomeData.meta.mobileposter;
        } else {
          state.poster = state.welcomeData.meta.poster;
        }
      }
      if (state.mode === 'landscape') {
        state.activeTab = null;
        state.hideTab = true;
      }
    },
    showControls(state, action) {
      if (!state.stopShowingControl) {
        state.showControl = true;
      }
    },
    hideControls(state, action) {
      if (!state.stopControlHiding && state.playerState === PLAYER_STATES.STARTED) {
        state.showControl = false;
      }
      if (
        (state.eventType === EVENT_TYPE.WB_RECORDING || state.eventType === EVENT_TYPE.WB_LIVE) &&
        state.playerState === PLAYER_STATES.STARTED
      ) {
        state.showControl = false;
      }
    },
    setNetworkError(state, action) {
      state.networkError = action.payload;
    },
    openScreenShotGallery(state, action) {
      state.ssPreview = true;
    },
    closeScreenShotGallery(state, action) {
      state.ssPreview = false;
    },
    setBanner(state, action) {
      state.banner = action.payload;
    },
    addBanner(state, action) {
      state.allBanners = [...state.allBanners, action.payload];
    },
    changeBanner(state, action) {},
    setClientScreenshot(state, action) {
      state.clientScreenshots = true;
    },
    setScreenshotList(state, action) {
      state.screenshotList = action.payload;
    },
    setPlayerVisibility(state, action) {
      state.playerVisibility = action.payload;
    },
    enableDRMode(state) {
      state.DRMode = true;
      state.showAudCount = true;
      state.screenshot = true;
      state.qna = true;
      state.config.qna = true;
      state.config.chatMode = CHAT_MODE.CDN_ONLY;
      state.config.stateMode = CHAT_MODE.CDN_ONLY;
    },
    setAliveData(state, action) {
      state.aliveData = action.payload;
    },
    setUserBlocked(state, action) {
      state.blocked = action.payload;
    },
    setSessionExpired(state, action) {
      if (state.limitedViewing) {
        state.sessionExpired = true;
      }
    },
    setChatDomLoaded(state, action) {
      state.chatDomLoaded = true;
    },
    setPlayerError(state, action) {
      state.playerError = action.payload;
    },
    setChatLoaded(state, action) {
      state.chatLoaded = action.payload;
    },
    setScreenShotConfig(state, action) {
      state.isScreenshotSupported = action.payload;
      state.config.screenshot = state.DRMode
        ? action.payload
          ? state.config.screenshot
          : false
        : state.config.screenshot;
    },
    setDocumentVisibility(state, action) {
      state.inActiveDuration = action.payload
        ? state.view === APP_VIEW.MAIN && state.playerState === PLAYER_STATES.STARTED && state.inActive
          ? (Date.now() - state.inActive) / 1000
          : null
        : null;
      state.inActive = action.payload
        ? null
        : state.view === APP_VIEW.MAIN && state.playerState === PLAYER_STATES.STARTED
        ? Date.now()
        : null;
      state.documentVisibility = action.payload;
    },
    setPlayerReadyForSS(state, action) {
      state.playerReadyForSS = true;
    },
    setSSexist(state, action) {
      state.ssExist = action.payload;
    },
    setCountDown(state, action) {},
    setLimitedSessionStart(state, action) {},
    setSSDeleteAll(state, action) {},
    setSSDownloadAll(state, action) {},
    sendQnaMessage(state, action) {},
    sendChatMessage(state, action) {},
    setSharePortal(state, action) {},
    streamHalted(state, action) {},
    streamChange(state, action) {},
    setShareBox(state, action) {
      state.shareBox = action.payload;
    },
    setBitRate(state, action) {
      state.bitRate = action.payload;
    },
    setPlayerStateResume(state, action) {},
    sendReaction(state, action) {
      state.reaction = action.payload;
    },
    payWallClick(state, action) {},
    setMute(state, action) {
      state.muted = action.payload;
    },
    setAutoPlayUnmute(state, action) {
      state.autoPlayUnmute = true;
    },
    toggleWelcomeSS(state, action) {
      state.welcomeSS = false;
    },
    setCastState(state, action) {
      state.castState = action.payload;
      state.loader = false;
      if (action.payload === CAST_STATE.CONNECTING) {
        state.loader = true;
      }
    },
    setCastReady(state) {
      state.castReady = true;
    },
    setCastVideoStarted(state, action) {
      state.castVideoStarted = action.payload;
    },
    setVideoVolume(state, action) {
      state.videoVolume = action.payload;
    },
    setCastDeviceName(state, action) {
      state.castDeviceName = action.payload;
    },
    setPipMode(state, action) {
      state.pipMode = action.payload;
    },
    setCrop(state, action) {
      state.crop = action.payload;
    },
    setApiKeyJson(state, action) {
      state.apiKeyJson = action.payload;
    },
    setPinnedMsg(state, action) {
      state.pinnedMsg = action.payload;
    },
    setGoLive(state, action) {},
    setMomentGA(state, action) {},
    setUnreadAdminMsgs(state, action) {
      if (state.activeTab === 'comments') {
        state.unreadAdminMsgs = [];
      } else if (state.unreadAdminMsgs.findIndex((msg) => msg.id === action.payload.id) === -1) {
        state.unreadAdminMsgs = [...state.unreadAdminMsgs, ...action.payload];
      }
    },
    deleteUnreadAdminMsg(state, action) {
      if (state.unreadAdminMsgs.length !== 0) {
        state.unreadAdminMsgs = state.unreadAdminMsgs.filter((msg) => msg.id !== action.payload.msgid);
      }
    },
    setShowCommentsRec(state, action) {
      state.showCommentsRec = action.payload;
      if (state.eventType === EVENT_TYPE.WB_RECORDING) {
        state.hideTab = !state.hideTab;
      }
    },
    setStopShowingControl(state, action) {
      state.stopShowingControl = action.payload;
    },
    setRecComments(state, action) {
      state.recordingComment = !state.recordingComment;
    },
    setForcedPlayerState(state, action) {
      state.forcedPlayerState = action.payload;
    },
    setLiveSdkLoaded(state, action) {
      state.livesdkLoaded = action.payload;
    },
    setForceDestroyed(state, action) {
      state.forceDestroyed = action.payload;
    },
    setSeekToLive(state, action) {
      state.seekToLive = action.payload;
    },
    updateMeta(state, action) {
      if (state.welcomeData) {
        state.welcomeData.meta = { ...state.welcomeData.meta, ...action.payload };
        state.enableDvr = action.payload?.enabledvr ?? false;
        state.config.controls = action.payload?.enabledvr ?? false;
        state.convertToVod = action.payload?.vod ?? false;
      }
    },
    updateCanvasMeta(state, action) {
      state.canvasMeta = { ...state.canvasMeta, ...action.payload };
    },
    setPlayerType(state, action) {
      state.config.ptype = action.payload;
    },
    addAudioStream(state, action) {
      state.audioStream = [...state.audioStream, action.payload];
    },
    setCallingState(state, action) {
      state.callingState = action.payload;
    },
    setReloadRtcPlayer(state, action) {
      state.reloadRtcPlayer = !state.reloadRtcPlayer;
    },
    setHandRaiseState(state, action) {
      state.handRaiseState = action.payload;
    },
    setCanvasLiveState(state, action) {
      state.canvasLiveState = action.payload;
    },
    addItemToCanvas(state, action) {
      const { id, remove, ...itemData } = action.payload;
      if (remove) {
        state.items = state.items.filter((o) => o.type !== itemData.type);
      }
      const idx = state.items.findIndex((o) => o.id === id);
      if (idx === -1) {
        state.items.push({ id, ...itemData });
      } else {
        state.items[idx] = { ...state.items[idx], ...itemData };
      }
    },
    addMultipleItemsToCanvas(state, action) {
      const canvasItems = action.payload?.canvas;
      if (!canvasItems) {
        return;
      }
      if (canvasItems.length === 0) {
        state.items = [];
      }
      for (const item of canvasItems) {
        const { id, ...itemData } = item;
        if (!id) {
          continue;
        }
        const idx = state.items.findIndex((o) => o.id === id);
        if (idx === -1) {
          state.items.push(item);
        } else {
          state.items[idx] = { ...state.items[idx], ...itemData };
        }
      }
    },
    removeFromCanvas(state, action) {
      const { id, type } = action.payload;
      if (type === '*') {
        // remove videoshare and screenshare for a user
        state.items = state.items.filter(
          (o) => !(o?.id?.includes(id) && [CANVAS_ITEM_TYPES.VIDEO, CANVAS_ITEM_TYPES.SCREEN].includes(o.type)),
        );
      } else {
        const idx = state.items.findIndex((o) => o.id === id);
        if (idx !== -1) state.items.splice(idx, 1);
      }
    },
    setAVToken(state, action) {
      state.welcomeData.avtoken = action.payload;
    },
    setChatRulesAccepted(state, action) {
      state.chatRulesState = true;
    },
    setPlaylistDetails(state, action) {
      state.playlistDetails = { ...action.payload };
    },
    updatePlaylistDetails(state, action) {
      state.playlistDetails = { ...state.playlistDetails, ...action.payload };
    },
    setCurrentPlayingIndex(state, action) {
      state.currentSimuliveIndex = action.payload;
    },
    setAdActive(state, action) {
      state.adActive = action.payload;
    },
    setVidDataLoaded(state, action) {
      state.vidDataLoaded = action.payload;
    },
  },
});

export default app.reducer;

export const {
  setLoader,
  setPoster,
  setAppConfig,
  setAppError,
  setWelcomeData,
  setSessionState,
  setAppView,
  setStateUpdate,
  proceedClick,
  setPlayerState,
  openTab,
  closeTab,
  takeScreenshotClick,
  resetTakeScreenshot,
  HidingControl,
  updateAudCount,
  forceStateUpdate,
  toggleFullScreen,
  setRecordings,
  addScreenShot,
  deleteScreenShot,
  handleResize,
  showControls,
  hideControls,
  setBanner,
  setNetworkError,
  openScreenShotGallery,
  closeScreenShotGallery,
  setClientScreenshot,
  setScreenshotList,
  setPlayerVisibility,
  enableDRMode,
  setAliveData,
  setUserBlocked,
  setSessionExpired,
  setChatDomLoaded,
  updateReactions,
  setPlayerError,
  setScreenShotConfig,
  setDocumentVisibility,
  setPlayerReadyForSS,
  setCountDown,
  setLimitedSessionStart,
  setSSDeleteAll,
  setSSDownloadAll,
  sendQnaMessage,
  sendChatMessage,
  setSharePortal,
  setShareBox,
  setBitRate,
  changeBanner,
  setPlayerStateResume,
  sendReaction,
  setSSexist,
  streamHalted,
  streamChange,
  setChatLoaded,
  payWallClick,
  setAutoPlayBehavior,
  setMute,
  setAutoPlayUnmute,
  toggleWelcomeSS,
  setCastState,
  setCastReady,
  setCastVideoStarted,
  setVideoVolume,
  setCastDeviceName,
  setPipMode,
  setCrop,
  setApiKeyJson,
  setPinnedMsg,
  setGoLive,
  setMomentGA,
  setUnreadAdminMsgs,
  deleteUnreadAdminMsg,
  setShowCommentsRec,
  setStopShowingControl,
  setRecComments,
  setGoogleLoginRequired,
  resetAppConfig,
  setForcedPlayerState,
  setLiveSdkLoaded,
  setForceDestroyed,
  setSSAdminData,
  setSeekToLive,
  updateMeta,
  setPlayerType,
  addAudioStream,
  setCallingState,
  setReloadRtcPlayer,
  setHandRaiseState,
  setCanvasLiveState,
  addItemToCanvas,
  addMultipleItemsToCanvas,
  removeFromCanvas,
  setAVToken,
  addBanner,
  setChatRulesAccepted,
  setPlaylistDetails,
  updatePlaylistDetails,
  setCurrentPlayingIndex,
  setAdActive,
  setClientConfig,
  updateCanvasMeta,
  setVidDataLoaded,
} = app.actions;
